// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","286":"8ab9a018","895":"component---src-templates-page-tsx"}[chunkId] || chunkId) + "-" + {"218":"458a1d89d1c225b5afd3","270":"a4944503f69c3e52e6b5","286":"3bd873bd4bd49251f32d","378":"9380a7ee8c29c29bf5a6","672":"bfd43d03778354c351d9","895":"34f1f9e70684c15ce0d6"}[chunkId] + ".js";
};